import PropTypes from 'prop-types';

import { useState } from 'react';

import { Button, Autocomplete, CircularProgress } from '@mui/joy'

import { InputField, InputFieldFrame } from './InputField';

import i18n from '@/i18n'

import { useEffect } from 'react';

import { Typography } from '@mui/joy';
import { authorizedFetch } from '@/client';
import { useManager } from '@/hooks';

export function SelectRelatedNode({
  placeholder,
  multiple=false,
  node,
  onChange,
  label,
  readOnly,
  nodeType,
  startDecorator
}) {
  const manager = useManager()

  const [selectedNode, setSelectedNode] = useState(node)

  const [loading, setLoading] = useState(false)

  const [q, setQ] = useState('')

  const [suggestedNodes, setSuggestedNodes] = useState([])

  useEffect(() => {
    setSelectedNode(node)
  }, [node])


  useEffect(() => {
    onChange(selectedNode)
  }, [selectedNode])


  const handleChange = (event, value) => {
    if (value) {
      setSelectedNode(value)
    }
  }

  const handleInputChange = event => {
    const value = event.target.value
    setQ(value)
  }

  useEffect(() => {
    setLoading(true)
    if (manager) {
      authorizedFetch("GET", `/${manager?.type}/${manager?.slug}/${nodeType}`, {}, { q }).then(result => {
        const nodes = result.results
        let filteredNodes = [...nodes].filter(n => n.name.indexOf(q) !== -1)
        if (filteredNodes.length > 30) {
          filteredNodes = filteredNodes.slice(0, 30)
        }
        setSuggestedNodes(filteredNodes)
        setLoading(false)
      })
    }
  }, [q])

  return (
    <InputField
      label={label}
    > 
      {selectedNode ? (
        <InputFieldFrame sx={{ p: 1, alignItems: 'center' }}>
          <Typography sx={{ flex: 1 }}>
            {(multiple && selectedNode instanceof Array) ? (
              selectedNode?.length > 2 ? i18n.t('multiple-values') : (selectedNode?.length === 1 ? selectedNode[0].name : '')
            ) : selectedNode?.name}
          </Typography>
          {!readOnly && <Button aria-label="Remove" variant="outlined" color="primary" onClick={() => setSelectedNode(null)}>{i18n.t('remove')}</Button>}
        </InputFieldFrame>
      ) : (
        <Autocomplete
          sx={{ flex: 1, p: '8px 12px' }}
          getOptionLabel={option => option.name}
          variant="outlined"
          readOnly={readOnly}
          multiple={multiple}
          placeholder={placeholder}
          getOptionKey={option => option.id}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          options={suggestedNodes}
          onChange={handleChange}
          onInputChange={handleInputChange}
          startDecorator={startDecorator}
          endDecorator={
            loading ? (
              <CircularProgress size="sm" sx={{ bgcolor: 'background.surface' }} />
            ) : null
          }
        /> 
      )}
    </InputField>
  )
}

SelectRelatedNode.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  multiple: PropTypes.bool,
  node: PropTypes.object,
  onChange: PropTypes.func,
  errors: PropTypes.array,
  readOnly: PropTypes.bool,
  nodeType: PropTypes.string,
  startDecorator: PropTypes.node,
  endDecorator: PropTypes.node,
  loading: PropTypes.bool,
  suggestedNodes: PropTypes.array,
  q: PropTypes.string,
  handleSelectNode: PropTypes.func,
  handleInputChange: PropTypes.func,
  handleChange: PropTypes.func
}